<template>
  <div class="mx-auto">
    <GotedoSpinnerLoader />
    <p class="text-center">Processing...</p>
  </div>
</template>

<script>
import GotedoSpinnerLoader from './GotedoSpinnerLoader.vue';
export default {
  name: 'GotedoProgressLoader',
  components: {
    GotedoSpinnerLoader,
  },
};
</script>
<style type="text/scss" scoped></style>
